<div class="flex h-full min-h-0 flex-col space-y-4">
	<div class="mx-6 flex">
		<mat-form-field
			appearance="fill"
			class="mat-form-field-no-hint flex-auto search"
		>
			<mat-label>{{ 'utils.search' | translate }}</mat-label>
			<input
				[cdkTrapFocusAutoCapture]="true"
				[formControl]="search"
				#searchElement
				cdkTrapFocus
				ignoreAutocomplete
				matInput
				type="text"
			>
		</mat-form-field>
	</div>
	<div
		cdkVirtualScrollingElement
		class="scroll-y h-[500px] min-h-0"
	>
		<ng-container *ngIf="entries$suggestions | async as suggestions">
			<ng-container *ngIf="suggestions.entries as entries">
				<div class="mx-4 mb-4 flex flex-row items-center justify-start gap-2 px-2">
					<mat-icon
						class="logo-icon"
						svgIcon="logoIcon"
					></mat-icon>
					<div class="flex flex-col">
						<h4
							class="my-0"
							translate
						>
							utils.suggestions
						</h4>
						<span
							class="mat-hint"
							translate
							>buzz.ki-suggestions</span
						>
					</div>
				</div>
				<div class="mx-4 mb-4 flex flex-row flex-wrap items-center justify-start gap-2">
					@for (entry of entries; let last = $last; track entry.id) {
					<mat-card
						(click)="submitProject({ project: entry, task: entry.task })"
						(contextmenu)="openContextMenu($event, projectMenuTrigger, { entry: entry })"
						[class.border-active]="entry.selected"
						[matTooltipOptions]="{ delay: [600, 0] }"
						[matTooltipTemplate]="projectPickerTooltip"
						[matTooltipTemplateContext]="{
                project: entry | projectProxy,
                tags: entry.tags,
              }"
						class="mat-card-button !mat-bg mb-2 cursor-pointer !rounded !px-3 !py-2"
						matTooltip
					>
						<mat-card-content class="flex">
							<div class="truncate-flex flex flex-auto flex-col">
								<div class="flex flex-row items-center justify-start gap-2">
									<div
										[matTooltip]="'project.color' | translate"
										[style.backgroundColor]="color"
										*ngIf="entry.color as color"
										class="project-color-dot self-center"
									></div>
									<h3
										[innerHTML]="entry | defaultEntityTranslate: 'project' : 'project.none' : null : true"
										class="mb-0 truncate text-base font-bold"
									></h3>
									<div class="mat-bg-30 h-1 w-1 rounded-full"></div>
									<span class="flex-shrink-0 truncate">{{
										entry.task?.name || ('task.none' | translate) | truncate: 40
									}}</span>
								</div>
							</div>
						</mat-card-content>
					</mat-card>
					}
				</div>
			</ng-container>
			<div class="mx-4 -mt-2 mb-4 flex items-center justify-end">
				<button
					(click)="showMore.value = !suggestions.showMore"
					*ngIf="suggestions.showMore !== undefined"
					class="link-button"
					color="primary"
					mat-button
				>
					{{ (showMore.value ? 'utils.show_less' : 'utils.show_more') | translate }}
				</button>
			</div>
		</ng-container>
		<cdk-virtual-scroll-viewport
			[itemSize]="52"
			[maxBufferPx]="4000"
			[minBufferPx]="1600"
			class="overflow-y-auto"
		>
			<div
				(click)="submitProject({ project: entry })"
				(mouseenter)="onItemMouseEnter()"
				(mouseleave)="onItemMouseLeave()"
				[matTooltip]="entry.description || ''"
				[matTooltipClass]="'whitespace-pre'"
				[matTooltipDisabled]="!entry.description || entry.description.trim().length === 0 || searchActive"
				[matTooltipOptions]="{ delay: [500, 0], offset: [0, -10], stretchToTrigger: true }"
				[matTooltipPosition]="'bottom-start'"
				[ngClass]="
          [
            first && last ? 'rounded-lg' : !last ? 'border-b' : first ? 'rounded-t-lg' : last ? 'rounded-b-lg' : null,
            first && !last && entry.selected && 'rounded-t-lg border-b-2',
            entry.selected ? 'mat-bg-5' : 'bg-background/40',
			entry.showUnpinnedDivider ? 'border-t-2 border-muted-foreground/50' : '',
          ] | clsx
        "
				*cdkVirtualFor="let entry of entries$filtered; trackBy: trackId; let last = last; let first = first"
				#el="nativeElement"
				class="flex pl-4 py-2 mx-6 h-13 cursor-pointer text-md border-b-muted-foreground/40"
				elementRef
			>
				<div class="flex flex-auto truncate items-center">
					<div class="truncate-flex flex flex-auto flex-col space-y-2">
						<div class="flex flex-row gap-2 truncate flex-shrink-0">
							<div class="flex items-center -ml-1 px-2 truncate">
								@if (entry.color; as color) {
								<div
									[matTooltip]="'project.color' | translate"
									class="size-3.5 flex items-center justify-center flex-col"
								>
									<div
										[style.backgroundColor]="color"
										class="size-3.5 rounded-circle"
									></div>
								</div>
								} @else {
								<div class="size-3.5"></div>
								}
							</div>
							@if(!entry.useAsDefault) {
							<div class="flex-fill flex flex-auto cursor-pointer flex-col items-stretch justify-start">
								<span
									[innerHTML]="entry | defaultEntityTranslate: 'project' : 'project.none' : null : true"
									class="mb-0 truncate text-base font-semibold"
								></span>
								<small class="mat-hint truncate">
									{{
										entry.client | defaultEntityTranslate: 'client' : 'client.none' | truncate: 100
									}}
								</small>
							</div>
							} @else {
							<h3
								[innerHTML]="entry | defaultEntityTranslate: 'project' : 'project.none' : null : true"
								class="mt-1.5 truncate text-base font-semibold"
							></h3>
							}
							<div class="!ml-auto flex flex-row items-center justify-start gap-2">
								<mat-icon
									[matTooltip]="'Billable_Alt' | translate"
									[ngClass]="entry.billable ? '' : 'invisible' "
									class="bg-accent-2 rounded-circle flex-none !p-1 text-lg"
									color="accent"
									inline
								>
									attach_money
								</mat-icon>
								<app-estimation-statistics-graph
									[completed]="entry.completed"
									[estimation]="entry.estimation || 0"
									[ngClass]="entry.estimation > 0 ? '' : 'invisible'"
									[recorded]="
                      entry.timesRecorded
                        ? (entry.timesRecorded.billable?.clamp(0, entry.timesRecorded.billable) || 0) +
                          (!entry.billable
                            ? entry.timesRecorded.notBillable?.clamp(0, entry.timesRecorded.notBillable) || 0
                            : 0)
                        : 0
                    "
									class="mb-1"
								></app-estimation-statistics-graph>
								@if(!entry.useAsDefault) {
								<div
									(click)="$event.stopPropagation(); openContextMenu($event, projectMenuTrigger, { entry: entry })"
									class="-ml-3"
								>
									<button
										(click)="$event.stopPropagation(); openContextMenu($event, projectMenuTrigger, { entry: entry })"
										class="flex flex-col items-center justify-center"
										mat-icon-button
									>
										<mat-icon>more_vert</mat-icon>
									</button>
								</div>
								}
							</div>
						</div>
					</div>
					@if ((showNextItemIcon.value$ | async) !== false) {
					<div class="flex items-center justify-center self-start">
						<mat-icon>keyboard_arrow_right</mat-icon>
					</div>
					}
				</div>
			</div>
		</cdk-virtual-scroll-viewport>
		<!-- <div class="pb-48"></div> -->
	</div>
</div>
<mat-menu #projectContextMenu>
	<ng-template
		let-entry="entry"
		matMenuContent
	>
		<div class="flex flex-col space-y-2">
			<button
				(click)="this.togglePinProject(entry.id)"
				mat-menu-item
			>
				<mat-icon inline>star</mat-icon>
				{{ (entry.pinned ? 'project.fav-disable' : 'project.fav-enable') | translate }}
			</button>
			<a
				(click.prevent)="openProject(entry.id)"
				[disabled]="entry.useAsDefault"
				[routerLink]="['/settings/projects', entry.id]"
				mat-menu-item
			>
				<mat-icon inline>folder</mat-icon>
				{{ 'project.open' | translate }}
			</a>
			@if(entry.pinned && !entry.firstPinned) {
			<button
				(click)="movePinnedProject(entry.id)"
				mat-menu-item
			>
				<mat-icon inline>arrow_upward</mat-icon>
				{{ 'project.moveFavouriteToTop' | translate }}
			</button>
			}
		</div>
	</ng-template>
</mat-menu>
<div
	[matMenuTriggerFor]="projectContextMenu"
	[style.left]="projectMenuPosition.x"
	[style.top]="projectMenuPosition.y"
	#projectMenuTrigger="matMenuTrigger"
	style="visibility: hidden; position: fixed"
></div>
<ng-template
	#projectPickerTooltip
	let-project="project"
	let-tags="tags"
>
	<div class="my-2 flex flex-col space-y-2 px-2.5 wflex-[1_0_220px]">
		<div class="space-y-1">
			<h3
				class="mat-hint text-sm italic"
				translate
			>
				client.single
			</h3>
			<div class="font-semibold">{{ project?.client | defaultEntityTranslate: 'client' : 'client.none' }}</div>
		</div>
		<div class="space-y-1">
			<h3
				class="mat-hint text-sm italic"
				translate
			>
				project.single
			</h3>
			<div
				[innerHTML]="project | defaultEntityTranslate: 'project' : 'project.none' : null : true"
				class="font-semibold"
			></div>
		</div>
		<div
			*ngIf="project?.description as desc"
			class="space-y-1"
		>
			<h3
				class="mat-hint text-sm italic"
				translate
			>
				Description
			</h3>
			<div>{{ desc | truncate: 120 }}</div>
		</div>
		<ng-container *ngIf="tags && tags.length > 0">
			<div class="space-y-1">
				<h3
					class="mat-hint text-sm italic"
					translate
				>
					tag.plural
				</h3>
				<div class="flex flex-wrap gap-2">
					<div
						*ngFor="let item of tags; trackBy: trackId"
						class="mbg-card pointer-events-none h-6 cursor-default select-none truncate rounded-full px-2.5 text-base leading-6"
					>
						{{ item.name }}
					</div>
				</div>
			</div>
		</ng-container>
	</div>
</ng-template>
